import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import _ from 'lodash';
import Cons from '../../isomorphic/cons';
import moment from 'moment';

@observer
export default class LastUpdatedBy extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const coordinators = this.props.coordinators.values(),
            createdByCoordinator = coordinators.find(user => user.coordinatorId === this.props.model.createdBy),
            createdOn = this.props.model.createdOn,
            updatedByCoordinator = coordinators.find(user => user.coordinatorId === this.props.model.updatedBy),
            updatedOn = this.props.model.updatedOn;

        return (
            <div>
                {updatedByCoordinator && updatedOn ? (
                    <h5>
                        <b>Last updated:</b> {updatedOn ? moment(updatedOn).format('L LT') : ''} by&nbsp;
                        {updatedByCoordinator ? updatedByCoordinator.name : ''}
                    </h5>
                ) : null}
                {createdByCoordinator && createdOn ? (
                    <h5>
                        <b>Created:</b> {createdOn ? moment(createdOn).format('L LT') : ''} by&nbsp;
                        {createdByCoordinator ? createdByCoordinator.name : ''}
                    </h5>
                ) : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/last-updated-by-component.js